import React, { useEffect, useState } from "react";
import $ from "jquery";
import useMatricula from "../hooks/useMatricula";
import { Link } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";

const ModalSoporte = () => {
  const { listadoSoporte } = useMatricula();
  const {listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  $("#support-button").on("click", function () {
    $("#support-container").show("slow");
    $("#support-container").addClass(".ani-fadeI");
    $(".soporte-content").addClass(".ani-fadeI");
    $(this).hide();
  });
  $("#close-support").on("click", function () {
    $("#support-container").hide();
    $("#support-button").show().addClass(".ani-fadeI");
  });

  useEffect(() => {
  
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        soporte_matricula: obtenerLabelEtiqueta(
          "lbl_soporte_matricula",
          listadoEtiquetas
        ),
      
      });
    }
  }, [listadoEtiquetas]);
  const { soporte_matricula } = etiquetas;

  return (
    <>
      <div
        className="btn-soporte va-middle animate__animated animate__fadeIn"
        id="support-button"
      >
        <i className="text-white far fa-headset" />
      </div>
      <div
        className="container-soporte animate__animated animate__fadeIn"
        id="support-container"
      >
        <div className="soporte-title d-flex justify-content-between">
          <h6>{soporte_matricula}</h6>
          <button type="button" className="btn-close" id="close-support" />
        </div>
        <div className="soporte-content py-3 px-3 animate__animated animate__fadeIn">
          {listadoSoporte.map((data, index) => {
            return (
                <p key={index}>
                  <Link to={data.turl}  style={{textDecoration:"none",color:"#212529"}}>
                  <i className={`far fa-envelope me-2 ${data.ticono} ${index!=0 && 'rotarIcono' }`} />{" "}
                  {data.tdescripcion}
                </Link>
                </p>
                
            );
          })}
 
        </div>
      </div>
    </>
  );
};

export default ModalSoporte;
